import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import './CidrSheet.css';

type CidrSheetProps = {
  title: string;
  closeLabel: string;
  onClose: () => void;
  children: ReactNode;
};

/**
 * CIDR プランナー用モーダルダイアログ
 */
export function CidrSheet({ title, closeLabel, onClose, children }: CidrSheetProps) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return createPortal(
    <div className="cidr-modal" role="presentation">
      <div className="cidr-modal__overlay" onClick={onClose} aria-hidden="true" />
      <div
        className="cidr-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cidr-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="cidr-modal__header">
          <h2 id="cidr-modal-title" className="cidr-modal__title">
            {title}
          </h2>
          <button
            type="button"
            className="cidr-modal__close-btn"
            onClick={onClose}
            aria-label={closeLabel}
          >
            ×
          </button>
        </div>
        <div className="cidr-modal__body">{children}</div>
      </div>
    </div>,
    document.body,
  );
}
